module.exports = __webpack_public_path__ + "img/cancelled.51cdeb00.svg";